import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject } from 'utils'

import { FETCH_STORE, FETCH_STORE_DONE, FETCH_STORE_ERROR, FETCH_STORE_SUCCESS } from './constants'
import type { Store, StoreResponse } from './types'

interface ReducerAction extends Action {
  payload: {
    storeId: number
    data: StoreResponse[]
    dateCurrent: RequestDate
  }
}

export default function store(state: Store = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_STORE:
      return {
        ...state,
        [payload.dateCurrent]: {
          ...(state[payload.dateCurrent] || emptyObject),
          [payload.storeId]: {
            ...(state[payload.dateCurrent]?.[payload.storeId] || emptyObject),
            isLoading: true,
          },
        },
      }
    case FETCH_STORE_DONE:
    case FETCH_STORE_ERROR:
      return {
        ...state,
        [payload.dateCurrent]: {
          ...(state[payload.dateCurrent] || emptyObject),
          [payload.storeId]: {
            ...(state[payload.dateCurrent][payload.storeId] || emptyObject),
            isLoading: false,
          },
        },
      }
    case FETCH_STORE_SUCCESS:
      return {
        ...state,
        [payload.dateCurrent]: {
          ...(state[payload.dateCurrent] || emptyObject),
          [payload.storeId]: {
            data: payload.data,
            isLoading: false,
          },
        },
      }
    default:
      return state
  }
}
